// LeasingCard.js
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { gtmEventPush } from 'utils/gtm/events';
import { formatExternalLink } from 'utils/utmLinks';

import isWindow from 'Common/isWindow';
import Icon from 'Common/Icon';
import Button from 'Common/Button';
import PartnershipLogo from 'Common/PartnershipLogo';
import SimpleModal from 'Common/SimpleModal';
import CarLeaseIndicator from 'Common/CarLeaseIndicator';
import { ATPhoneNumber } from '../../utils/constants';
import parsedPrice from 'Common/parsedPrice';

import styles from 'components/LeasingCard.scss';

class LeasingCard extends Component {
  constructor(props) {
    super(props);
    this.state = {
      enablePriceIndicatorInfo: false,
      indicatorType: ''
    };
  }

  static propTypes = {
    make: PropTypes.string,
    range: PropTypes.string,
    fuelType: PropTypes.string,
    engine: PropTypes.string,
    doors: PropTypes.number,
    personalLeasePrice: PropTypes.string,
    businessLeaselPrice: PropTypes.string,
    transmission: PropTypes.string,
    history: PropTypes.object,
    item: PropTypes.object,
    url: PropTypes.string,
    network: PropTypes.string,
    gcLid: PropTypes.string,
    gtmSectionName: PropTypes.string.isRequired,
    handleClick: PropTypes.func,
    isMobile: PropTypes.bool,
    model: PropTypes.string,
    generation: PropTypes.string,
    derivative: PropTypes.string,
    trim: PropTypes.string,
    bodyType: PropTypes.string,
    isStockCarsCard: PropTypes.bool,
    dueDate: PropTypes.number,
    productId: PropTypes.string,
    dataSection: PropTypes.string,
    utm: PropTypes.string,
    isModelSelected: PropTypes.string
  };

  handleClick = e => {
    const { item, handleClick } = this.props;
    e.preventDefault();
    handleClick(item);
    const url = this.generateUrl();
    isWindow && window.open(url, '_blank');
  };

  handleClickChild = (e, name) => {
    e.stopPropagation();
    gtmEventPush({
      method: this.props.gtmSectionName,
      args: {
        itemLabel: `Result page - ${name}`
      }
    });
    this.handleClick(e);
  };

  setPriceIndicatorInfoLook = e => {
    document.body.style.overflow = 'unset';
    this.setState({
      enablePriceIndicatorInfo: false
    });
  };

  generateUrl = () => {
    const { network, gcLid, url, utm } = this.props;
    const linkParams = {
      link: url,
      network,
      gcLid
    };
    const uri = formatExternalLink(linkParams, utm);
    return uri;
  };

  togglePriceIndicatorInfo = e => {
    e.preventDefault();
    this.setState(prevState => ({
      enablePriceIndicatorInfo: !prevState.enablePriceIndicatorInfo
    }));
  };

  render() {
    const {
      isMobile,
      make,
      range,
      engine,
      trim,
      personalLeasePrice,
      businessLeaselPrice,
      fuelType,
      transmission,
      doors,
      productId,
      generation,
      derivative,
      bodyType,
      dataSection,
      item,
      isModelSelected
    } = this.props;

    const { enablePriceIndicatorInfo, indicatorType } = this.state;

    let businessLeaseLabel = isMobile
      ? 'Business monthly lease'
      : 'Business lease';
    let personalLeaseLabel = isMobile
      ? 'Personal monthly lease'
      : 'Personal lease';
    if (!isModelSelected) {
      businessLeaseLabel = 'Business lease';
      personalLeaseLabel = 'Personal lease';
    }

    const personalInitalPayment =
      item &&
      item.leasingData &&
      item.leasingData.initialPayment &&
      item.leasingData.initialPayment.personal;
    const personalInitalPrice = parsedPrice(personalInitalPayment);

    const termMonths = item && item.leasingData && item.leasingData.termMonths;
    const totalMileage =
      item && item.leasingData && item.leasingData.totalMileage;
    const url = this.generateUrl();
    const SpecificationList = (
      <ul className={styles.specificationList}>
        {fuelType && (
          <li className={styles.detail} data-fuel-type>
            {fuelType}
          </li>
        )}
        {transmission && (
          <li className={styles.detail} data-fuel-type>
            {transmission !== 'N/A'
              ? transmission[0].toUpperCase() +
                transmission.substring(1).toLowerCase()
              : transmission}
          </li>
        )}
        {doors && (
          <li className={styles.detail} data-fuel-type>
            {doors} Doors
          </li>
        )}
      </ul>
    );

    return (
      <div className={styles.leasingCards}>
        {item && item.inStock && (
          <div className={styles.inStock}>
            <div>In Stock</div>
          </div>
        )}
        <div className={styles.card}>
          <div
            className={classNames(
              styles.customSection,
              !isModelSelected && styles.customSectionNoModel
            )}
          >
            {isModelSelected ? (
              <React.Fragment>
                <h3 className={styles.title}>
                  {make} {range}
                </h3>

                <div className={styles.specs}>
                  {engine && (
                    <div className={styles.spec}>
                      <span className={styles.label}>Engine:</span>
                      <span className={styles.value}>{`${engine}L`}</span>
                    </div>
                  )}
                  {trim && (
                    <div className={styles.spec}>
                      <span className={styles.label}>Trim:</span>
                      <span className={styles.value}>{trim}</span>
                    </div>
                  )}
                </div>
              </React.Fragment>
            ) : (
              <div className={styles.specs}>
                <a
                  href={url}
                  rel="nofollow"
                  data-section={dataSection}
                  product-id={productId}
                  make={make}
                  model={range}
                  generation={generation}
                  derivative={derivative}
                  trim={trim}
                  bodytype={bodyType}
                  fueltype={fuelType}
                  range={range}
                  transmission={transmission}
                  data-bi="autotrader-click"
                >
                  {item.images.length > 0 ? (
                    <img
                      src={item.images[0].href}
                      alt={item.images[0].source}
                    />
                  ) : (
                    <img
                      src={`${process.env.PUBLIC_URL ||
                        ''}/images/fallback.png`}
                      alt={'Image unavailable'}
                      title={'Image unavailable'}
                    />
                  )}
                </a>
              </div>
            )}
            <div className={styles.nonModelTitleMobile}>
              {isMobile && (
                <div className={styles.nonModelTitle}>
                  <h3 className={styles.title}>
                    <a
                      href={url}
                      rel="nofollow"
                      data-section={dataSection}
                      product-id={productId}
                      make={make}
                      model={range}
                      generation={generation}
                      derivative={derivative}
                      trim={trim}
                      bodytype={bodyType}
                      fueltype={fuelType}
                      range={range}
                      transmission={transmission}
                      data-bi="autotrader-click"
                    >
                      {make} {range}
                    </a>
                  </h3>

                  <div className={styles.specs}>
                    {engine && (
                      <div className={styles.spec}>
                        <span className={styles.label}>Engine:</span>
                        <span className={styles.value}>{`${engine}L`}</span>
                      </div>
                    )}
                    {trim && (
                      <div className={styles.spec}>
                        <span className={styles.label}>Trim:</span>
                        <span className={styles.value}>{trim}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}

              {SpecificationList}
            </div>
          </div>

          <React.Fragment>
            <div className={classNames(styles.divider, styles.largeDivider)} />
            <div className={styles.nonModelContainer}>
              {!isMobile && (
                <div className={styles.nonModelTitle}>
                  <h3 className={styles.title}>
                    <a
                      href={url}
                      rel="nofollow"
                      data-section={dataSection}
                      product-id={productId}
                      make={make}
                      model={range}
                      generation={generation}
                      derivative={derivative}
                      trim={trim}
                      bodytype={bodyType}
                      fueltype={fuelType}
                      range={range}
                      transmission={transmission}
                      data-bi="autotrader-click"
                    >
                      {make} {range}
                    </a>
                  </h3>

                  <div className={styles.specs}>
                    {engine && (
                      <div className={styles.spec}>
                        <span className={styles.label}>Engine:</span>
                        <span className={styles.value}>{`${engine}L`}</span>
                      </div>
                    )}
                    {trim && (
                      <div className={styles.spec}>
                        <span className={styles.label}>Trim:</span>
                        <span className={styles.value}>{trim}</span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              <div className={classNames(styles.section, styles.largeSection)}>
                <div className={styles.personalLeaseWrapper}>
                  <div className={styles.LeaseWrapperInner}>
                    <span className={styles.personalLeaseLabel}>
                      {personalLeaseLabel}
                      <Icon
                        iconName={'info'}
                        size={'medium'}
                        onClick={e => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.setState({
                            enablePriceIndicatorInfo: !enablePriceIndicatorInfo,
                            indicatorType: 'Personal'
                          });
                        }}
                        className={styles.info}
                      />
                    </span>
                    <span className={styles.personalLeasePrice}>
                      {personalLeasePrice}
                    </span>
                    {(!isMobile || !isModelSelected) && (
                      <span className={styles.perMonth}>per month</span>
                    )}
                  </div>
                  <div>
                    <p className={styles.payments}>
                      <strong>{personalInitalPrice}</strong> initial payment.{' '}
                      <strong>{termMonths}</strong> month contract.{' '}
                      <strong>{totalMileage}</strong> miles p/a. Subject to
                      status and conditions
                    </p>
                  </div>
                </div>
              </div>

              {!isMobile && <div className={classNames(styles.divider)} />}

              <div className={classNames(styles.section, styles.largeSection)}>
                <div className={styles.businessLeaseWrapper}>
                  <div className={styles.LeaseWrapperInner}>
                    <span className={styles.businessLeaseLabel}>
                      {businessLeaseLabel}

                      <Icon
                        iconName={'info'}
                        size={'medium'}
                        onClick={e => {
                          e.stopPropagation();
                          e.preventDefault();
                          this.setState({
                            enablePriceIndicatorInfo: !enablePriceIndicatorInfo,
                            indicatorType: 'Business'
                          });
                        }}
                        className={styles.info}
                      />
                    </span>
                    <span className={styles.businessLeaseLabelPrice}>
                      {businessLeaselPrice}
                    </span>
                    {(!isMobile || !isModelSelected) && (
                      <span className={styles.perMonth}>per month</span>
                    )}
                  </div>
                  <div>
                    <p className={styles.payments}>
                      <strong>{personalInitalPrice}</strong> initial payment.{' '}
                      <strong>{termMonths}</strong> month contract.{' '}
                      <strong>{totalMileage}</strong> miles p/a. Subject to
                      status and conditions
                    </p>
                  </div>
                </div>
              </div>
              <div className={classNames(styles.section, styles.sectionButton)}>
                <Button
                  type={'primary'}
                  href={url}
                  rel="nofollow"
                  extendStyle={classNames(
                    styles.fullVehicleButton,
                    styles.externalButton
                  )}
                  dataSection={dataSection}
                  productId={productId}
                  make={make}
                  model={range}
                  generation={generation}
                  derivative={derivative}
                  trim={trim}
                  bodyType={bodyType}
                  fuelType={fuelType}
                  range={range}
                  transmission={transmission}
                  dataBi="autotrader-click"
                  buttonText={
                    <Fragment>
                      View deal
                      <Icon
                        className={classNames(styles.externalIcon)}
                        iconName={'newwindow'}
                        size={'default'}
                      />
                    </Fragment>
                  }
                />
                <Button
                  type={'primary'}
                  href={ATPhoneNumber}
                  extendStyle={classNames(styles.callNowButton)}
                  attributeTarget={'_self'}
                  buttonText={
                    <Fragment>
                      <Icon
                        className={classNames(styles.callIcon)}
                        iconName={'phone2'}
                        size={'deafault'}
                      />
                      Call Now
                    </Fragment>
                  }
                />

                {(isMobile || !isModelSelected) && (
                  <PartnershipLogo
                    extendStyle={
                      !isModelSelected
                        ? styles.partnerLogoModel
                        : styles.partnerLogo
                    }
                  />
                )}
              </div>
            </div>
          </React.Fragment>

          {enablePriceIndicatorInfo && (
            <SimpleModal
              closeIcon={'close'}
              onClose={this.setPriceIndicatorInfoLook}
              isModalOpen={enablePriceIndicatorInfo}
            >
              <button
                className={styles.closeButton}
                onClick={this.setPriceIndicatorInfoLook}
              >
                Close
              </button>
              {indicatorType === 'Personal' && (
                <CarLeaseIndicator
                  indicatorType={'Personal'}
                  expectedAnnualMileage={item.leasingData.totalMileage}
                  initialPayment={item.leasingData.initialPayment.personal}
                  depositMonths={item.leasingData.depositMonths}
                  termMonths={item.leasingData.termMonths}
                  monthlyPayment={personalLeasePrice}
                  derivative={derivative}
                  isMobile={isMobile}
                />
              )}

              {indicatorType === 'Business' && (
                <CarLeaseIndicator
                  indicatorType={'Business'}
                  expectedAnnualMileage={item.leasingData.totalMileage}
                  initialPayment={item.leasingData.initialPayment.business}
                  depositMonths={item.leasingData.depositMonths}
                  termMonths={item.leasingData.termMonths}
                  monthlyPayment={businessLeaselPrice}
                  derivative={derivative}
                  isMobile={isMobile}
                />
              )}
            </SimpleModal>
          )}
        </div>
      </div>
    );
  }
}

export default LeasingCard;



// WEBPACK FOOTER //
// ./src/Common/LeasingCard/index.js